import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, XMarkIcon } from '@heroicons/react/24/solid';

const ComparisonSection: React.FC = () => {
  const features = [
    {
      name: "Beautiful Design",
      description: "Aesthetic pomodoro timer with modern interface",
      us: true,
      others: false
    },
    {
      name: "Cross-Platform",
      description: "Works on Mac, Windows, and mobile devices",
      us: true,
      others: true
    },
    {
      name: "Task Management",
      description: "Built-in task tracking and statistics",
      us: true,
      others: false
    },
    {
      name: "Custom Intervals",
      description: "Adjustable work and break durations",
      us: true,
      others: false
    },
    {
      name: "Sound Notifications",
      description: "Customizable audio alerts",
      us: true,
      others: true
    },
    {
      name: "Progress Tracking",
      description: "Detailed statistics and insights",
      us: true,
      others: false
    }
  ];

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 0.5 }}
      className="w-full max-w-4xl mx-auto px-4 sm:px-6 py-8"
    >
      <h2 className="text-2xl sm:text-3xl font-bold text-white text-center mb-8">
        Why Choose Our Timer?
      </h2>
      <div className="bg-white/10 backdrop-blur-lg rounded-xl overflow-hidden">
        <div className="grid grid-cols-4 gap-4 p-6 text-white font-semibold border-b border-white/10">
          <div className="col-span-2">Feature</div>
          <div className="text-center">Our Timer</div>
          <div className="text-center">Others</div>
        </div>
        {features.map((feature, index) => (
          <motion.div
            key={feature.name}
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ delay: 0.1 * index }}
            className="grid grid-cols-4 gap-4 p-6 text-white/90 border-b border-white/10 hover:bg-white/5 transition-colors"
          >
            <div className="col-span-2">
              <p className="font-medium">{feature.name}</p>
              <p className="text-sm text-white/70">{feature.description}</p>
            </div>
            <div className="flex justify-center items-center">
              {feature.us ? (
                <CheckIcon className="w-6 h-6 text-green-400" />
              ) : (
                <XMarkIcon className="w-6 h-6 text-red-400" />
              )}
            </div>
            <div className="flex justify-center items-center">
              {feature.others ? (
                <CheckIcon className="w-6 h-6 text-green-400" />
              ) : (
                <XMarkIcon className="w-6 h-6 text-red-400" />
              )}
            </div>
          </motion.div>
        ))}
      </div>
    </motion.div>
  );
};

export default ComparisonSection;
